import { useEffect, useMemo } from "react";
import BackArrow from "../../components/BackArrow";
import { useLocation, useNavigate } from "react-router-dom";
import AppButton from "../../components/AppButton";
import { routes } from "../../helpers/constants";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { reqToGetRestaurantDetailsFromIDB } from "../../store/slice/indexedDBSlice";
import { checkIsValidArray } from "../../helpers/commonFunction";

const CompanyItemStart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    type,
    realType,
    showUpload,
    selectedItem,
    selectedLocation,
    selectedRestaurant,
  } = location.state || {};

  useEffect(() => {
    if (!selectedItem || !selectedItem?.id) {
      navigate(routes.dashboard);
    }
  }, []);

  const { restaurantList, govermentMarketList, isRestaurantListIDBChecked } =
    useSelector(
      (state) => ({
        restaurantList: state.indexedDBReducer?.restaurantList,
        govermentMarketList: state.indexedDBReducer?.govermentMarketList,
        isRestaurantListIDBChecked:
          state.indexedDBReducer?.isRestaurantListIDBChecked,
      }),
      shallowEqual
    );

  useEffect(() => {
    if (!isRestaurantListIDBChecked) {
      dispatch(reqToGetRestaurantDetailsFromIDB({}));
    }
  }, [restaurantList, govermentMarketList, isRestaurantListIDBChecked]);

  // CURRENT SELECTED RESTAURANT
  const currSRestaurant = useMemo(() => {
    const newRestaurantList =
      type === "COMPANY" || type === "cReports"
        ? restaurantList
        : govermentMarketList;

    if (!checkIsValidArray(newRestaurantList)) {
      return selectedRestaurant;
    }

    const sRestaurant = newRestaurantList.find(
      (item) => item.id === selectedRestaurant.id
    );
    return sRestaurant || selectedRestaurant;
  }, [restaurantList, govermentMarketList]);

  // CURRENT SELECTED ITEM
  const currSItem = useMemo(() => {
    if (!currSRestaurant || currSRestaurant?.location?.length === 0) {
      return selectedItem;
    }

    const currResItem = currSRestaurant?.location.find(
      (loc) => loc.name === selectedLocation
    );
    if (!currResItem || currResItem?.items?.length === 0) return selectedItem;

    const currResSItem = currResItem?.items.find(
      (sub) => sub.id === selectedItem.id
    );
    return currResSItem || selectedItem;
  }, [currSRestaurant]);

  const checkISBtnGreen = (item) => {
    if (!Array.isArray(item?.item_report) && item?.item_report?.length === 0) {
      return false;
    } else if (item?.item_report?.length >= 3) {
      return true;
    } else {
      return false;
    }
  };

  const handleNavigate = (btn, isReport) => {
    if ((type === "COMPANY" || type === "GOVERMENT") && !isReport) {
      navigate(routes.companyReportStage, {
        state: {
          ...location.state,
          selectedItem: currSItem,
          selectedRestaurant: currSRestaurant,
          selectedLocation: selectedLocation,
          selectedSubItem: btn,
          showUpload: showUpload,
        },
      });
    } else {
      navigate(routes.siphoningSummary, {
        state: {
          ...location.state,
          selectedItem: currSItem,
          selectedRestaurant: currSRestaurant,
          selectedLocation: selectedLocation,
          selectedSubItem: btn,
          showUpload: showUpload,
        },
      });
    }
  };

  return (
    <div className="tcl-raffles-makati-page tcl-raffles-makati-details-page">
      <div className="tcl-raffles-makati-wrapper">
        <BackArrow
          handleClick={() =>
            navigate(
              (type === "cReports" || type === "gReports") &&
                realType === "COMPANY"
                ? routes.companyItemList
                : type === "COMPANY" || type === "GOVERMENT"
                ? routes.companyItemDetails
                : routes.reportItemDetails,
              { state: { ...location?.state, type: realType || type } }
            )
          }
        />
        <div className="tcl-personal-wrapper">
          <div className="btn-wrapper">
            {Array.isArray(currSItem?.sub_items) &&
              currSItem?.sub_items.map((btn, index) => {
                const isBtnGreen = checkISBtnGreen(btn);
                if ((type === "cReports" || type === "gReports") && !isBtnGreen)
                  return null;
                return (
                  <AppButton
                    item={btn}
                    key={index}
                    title={btn.name}
                    isBtnGreen={isBtnGreen}
                    onClick={() => handleNavigate(btn, isBtnGreen)}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyItemStart;
